import React from 'react'
import { Modal, Pressable, StyleSheet, Text, View } from 'react-native'
import { useRouter } from 'expo-router'
import { DS } from '@/design-system'
import { translate } from '../../i18n/translate'
import { fontFamily } from '../../theme/fontFamily'

type Props = {
  visible: boolean
  onDismiss: () => void
}

export function LoungeFullModal({ visible, onDismiss }: Props) {
  const router = useRouter()

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onDismiss}>
      <View style={styles.modalBackdrop}>
        <Pressable style={StyleSheet.absoluteFill} onPress={onDismiss} />
        <View style={styles.modalCard}>
          <Text allowFontScaling={false} style={styles.modalTitle}>
            {translate('loungeFullModal.title')}
          </Text>
          <Text allowFontScaling={false} style={styles.modalBody}>
            {translate('loungeFullModal.body')}
          </Text>
          <DS.Button
            type="On Light"
            variant="Large/Primary"
            backgroundColor="Brand/Maroon"
            onPress={() => {
              onDismiss()
              router.push('/lounges/create' as never)
            }}
          >
            {translate('loungeFullModal.createLounge')}
          </DS.Button>
        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.35)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  modalCard: {
    width: '100%',
    maxWidth: 400,
    zIndex: 1,
    backgroundColor: DS.palette['Brand/Cream'],
    borderRadius: 16,
    paddingVertical: 28,
    paddingHorizontal: 24,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8
  },
  modalTitle: {
    fontFamily: fontFamily.FeatureDeckBold,
    fontSize: 26,
    lineHeight: 32,
    color: DS.palette['Global/Black'],
    textAlign: 'center',
    marginBottom: 16
  },
  modalBody: {
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontSize: 16,
    lineHeight: 24,
    color: DS.palette['Global/Black'],
    textAlign: 'center',
    marginBottom: 24
  }
})
